// MerchMod entry. Separate bundle from Tattune (see merch.html) so
// Tattune's global CSS and app state never load here.
//
// Routes (work on merchmod.ca/… (merchally.ca too) and tattune.ca/merch/…):
//   /                    designer (on merchmod.ca: the overview page)
//   /demo                designer on merchmod.ca
//   /order/:id?t=token   customer order status
//   /admin               review queue
//   /view/:id            read-only 3D view of a saved design
//   /privacy             privacy policy
//   /?d=<id>&k=<token>   open a saved design to keep editing
import React from "react";
import { createRoot } from "react-dom/client";
import MerchApp from "./MerchApp.jsx";
import OrderStatus from "./OrderStatus.jsx";
import MerchAdmin from "./MerchAdmin.jsx";
import DesignViewer from "./DesignViewer.jsx";
import PrivacyPage from "./PrivacyPage.jsx";
import { loadDesignData, applyDesign } from "./designs";
import { startAutosave } from "./persist";
import "./merch.css";

import Overview from "./Overview.jsx";
import { PREFIX as prefix, DESIGNER_HREF, ON_MERCHMOD_HOST, IS_MERCHMOD, applyStoreTheme } from "./stores";

applyStoreTheme();
const path = window.location.pathname.slice(prefix.length) || "/";
const params = new URLSearchParams(window.location.search);
const homeHref = DESIGNER_HREF;
// merchmod.ca/ is the overview, unless the URL is one of the app's own
// links (saved design, cancelled checkout) that land on the root
const appParams = params.has("d") || params.has("cancelled") || params.has("dev");
const isOverview = ON_MERCHMOD_HOST && IS_MERCHMOD && /^\/?$/.test(path) && !appParams;

let page;
const orderMatch = path.match(/^\/order\/([0-9a-f-]{36})\/?$/i);
const viewMatch = path.match(/^\/view\/([0-9a-f-]{36})\/?$/i);
if (isOverview) {
  page = <Overview demoHref={DESIGNER_HREF} />;
} else if (/^\/privacy\/?$/.test(path)) {
  page = <PrivacyPage homeHref={homeHref} />;
} else if (viewMatch) {
  page = <DesignViewer designId={viewMatch[1]} homeHref={homeHref} />;
} else if (/^\/admin\/?$/.test(path)) {
  page = <MerchAdmin homeHref={homeHref} />;
} else if (orderMatch) {
  page = (
    <OrderStatus
      orderId={orderMatch[1]}
      token={params.get("t") || ""}
      justPaid={params.get("paid") === "1"}
      homeHref={homeHref}
    />
  );
} else if (params.get("d") && params.get("k")) {
  // saved-design link: load it (instead of the local autosave), then keep
  // autosaving; tidy the URL so a refresh doesn't reload over new edits
  const id = params.get("d"), token = params.get("k");
  loadDesignData(id)
    .then(({ data }) => applyDesign(data, { id, editToken: token }))
    .catch((e) => window.alert(e.message || "Couldn't open that design."))
    .finally(() => {
      startAutosave({ restore: false });
      window.history.replaceState(null, "", DESIGNER_HREF);
    });
  page = <MerchApp />;
} else {
  startAutosave();
  page = <MerchApp cancelled={params.get("cancelled") === "1"} />;
}

createRoot(document.getElementById("root")).render(page);
